module.exports = __webpack_public_path__ + "5bfecb738a91626eb0d9c3409dcb1c30.png";